import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Sabbatical week day 1: Toshl and Toggl datasets",
  "description": "",
  "published": "2011-12-27T00:00:00.000Z",
  "redirect_from": ["/blog/sabbatical-week-day-1-toshl-and-toggl-datasets/swizec/3277"],
  "categories": "Accounting, Apps, Klok, Machine learning, Time Tracking, Toshl, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`I'm taking a sabbatical week over the holidays. This week's posts will serve as a sort of report of what I got up to the previous day instead of the usual schedule - wish me luck that I achieve even half of what I'd like to.`}</em></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/65197v5-max-250x2503.jpg",
        "alt": "Image representing Toshl as depicted in CrunchBase",
        "title": "Image representing Toshl as depicted in CrunchBase"
      }}></img></p>
    <p><a parentName="p" {...{
        "href": "http://toshl.com",
        "title": "Toshl"
      }}>{`Toshl`}</a>{` is a cool expense tracking app from Slovenia, that I have been using since November last year as it turns out. I just love collecting data that I never really look at - I think the only times when I actually went back to inspect my Toshl data were those `}<em parentName="p">{`holy fuck, why am I suddenly out of money, where'd it all go!?`}</em>{` moments.`}</p>
    <p>{`It was never the bank's mistake :(`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.toggl.com",
        "title": "Toggl.com"
      }}>{`Toggl`}</a>{` is perhaps more widely known - possibly the simplest time tracker I have come across. Started using it in early June as a companion app to my `}<a parentName="p" {...{
        "href": "http://klok.mcgraphix.com/klok/index.htm",
        "title": "Klok"
      }}>{`Klok`}</a>{` data for tracking productive productive time (the definition for Klok also includes things like exercise and chores for instance). In September or October I tightened up my use a bit further so Toggl only includes my billable time now.`}</p>
    <p>{`Combined Toshl and Toggl give me this awesome dataset to play with - a near daily report of my expected income and my actual expenses.`}</p>
    <p>{`The next step is obvious - I'm making a service for myself that, once a week:`}</p>
    <ul>
      <li parentName="ul">{`fetches toshl and toggl data`}</li>
      <li parentName="ul">{`runs a simple `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Machine_learning",
          "title": "Machine learning"
        }}>{`machine learning algorithm`}</a></li>
      <li parentName="ul">{`sends me an email along the lines of `}<em parentName="li">{`Hey dude, you're gonna run out of money in two weeks. Just thought I'd mention that`}</em></li>
    </ul>
    <p>{`Yesterday I made the fetching part in `}<a parentName="p" {...{
        "href": "http://nodejs.org/",
        "title": "Node.js"
      }}>{`node.js`}</a>{` - a surprisingly difficult task when there's no ready-made Toggl library and Toshl doesn't even have an official API - and I'm tackling the learning bit today ... perhaps even in `}<a parentName="p" {...{
        "href": "http://haskell.org",
        "title": "Haskell (programming language)"
      }}>{`Haskell`}</a>{`. That should be interesting and couldn't possibly fail right?`}</p>
    <p>{`Oh and if you ever find yourself in a situation where you have to reverse engineer an API from web forms make sure to send the `}<em parentName="p">{`'Content-Type': 'application/x-www-form-urlencoded'`}</em>{` header. Wasted at least an hour trying to figure out why my requests worked perfectly with Curl but not in Node.js.`}</p>
    <p>{`Of course it also helps if your target doesn't have csrf protection; thanks for that Toshl team. You guys are awesome :)`}</p>
    <p>{`PS: ping me if you think this sort of service could be useful to you too`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://markos.gaivo.net/blog/?p=604"
        }}>{`Review of expense tracker Toshl`}</a>{` (markos.gaivo.net)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.alwayssaving.com/money-saving-smartphone-apps/"
        }}>{`Money-saving smartphone apps`}</a>{` (alwayssaving.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.makeuseof.com/tag/toggl-helps-discover-time/"
        }}>{`Toggl Helps You Discover Where Your Time Goes`}</a>{` (makeuseof.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://theworkathomewife.com/top-10-freelance-time-tracking-tools/"
        }}>{`Top 10 Freelance Time Tracking Tools`}</a>{` (theworkathomewife.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://mashable.com/2011/12/10/time-keeping-apps/"
        }}>{`5 Timekeeping Apps for Your Small Business`}</a>{` (mashable.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/8490093/node-js-share-sockets-between-processes"
        }}>{`node.js - share sockets between processes`}</a>{` (stackoverflow.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.intomobile.com/2011/11/04/mobile-expense-tracking-service-toshl-gets-brand-new-android-app/"
        }}>{`Mobile expense tracking service Toshl gets a brand new Android app`}</a>{` (intomobile.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=75f5e7d0-daac-4773-870d-c83333331ef0",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      